<app-header [showLogout]="false" [showTitle]="false" [showBack]="showBack"></app-header>
<div id="surveyElement" style="display:inline-block;width:100%;margin: 10px auto 32px;"></div>
<div id="surveyResult">{{surveyResult}}</div>
<!-- <div class="footer">
  <p>&copy; Copyright 2021</p>
</div> -->